// This compares the key field for two objects.
// Returns: -1 if o1[key] < o2[key]
//           0 if o1[key] === o2[key]
//          +1 if o1[key] > o2[key]
//
// Ex: Use in a sort() to alphabetize the displayable labels 
// for a filterInput.
export default function compareObjectKeys(key, ignoreCase) {
  return (o1, o2) => {
    if (ignoreCase) {
      return o1[key].localeCompare(o2[key]);
    }
    else {
      return (o1[key] === o2[key]) ?
        0 :
        (o1[key] < o2[key]) ?
          -1 :
          1;
    }
  }
}


// WEBPACK FOOTER //
// ./src/shared/functions/compareObjectKeys.js